module.exports = __webpack_public_path__ + "static/askmedIcon-d584314b9b94a63a71ce7b44c27219e7.png";